import React, { Component, Fragment } from 'react'
import AlertMessage from 'react-s-alert'
import 'react-s-alert/dist/s-alert-default.css'
import 'react-s-alert/dist/s-alert-css-effects/scale.css'
import { AlertStyles } from './styles'

class Alert extends Component {
  render() {
    return (
      <Fragment>
        <AlertMessage stack={{ limit: 7 }} />
        <AlertStyles />
      </Fragment>
    )
  }
}

export const handleErrorMessageAlert = (errorMessage: string): void => {
  AlertMessage.error(errorMessage, {
    position: 'top-right',
    effect: 'scale',
    timeout: 2000
  })
}

export const handleSuccessMessageAlert = (errorMessage: string): void => {
  AlertMessage.success(errorMessage, {
    position: 'top-right',
    effect: 'scale',
    timeout: 2000
  })
}

export const handleCloseAllAlerts = (): void => {
  AlertMessage.closeAll()
}

export default Alert
